import { runtimeEnv } from 'config/runtimeEnv';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const getPlacardPreview = async (payload) => {
  try {
    // If payload contains tripId, use it, otherwise use text
    const endpoint = `${env}/trip-api/v3/placard`;
    const requestPayload = payload.tripId ? { tripId: payload.tripId } : { text: payload.text };

    const response = await requestInstance.post(endpoint, requestPayload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.data.success && response.data.data.svgBase64) {
      return {
        success: true,
        imageUrl: `data:image/svg+xml;base64,${response.data.data.svgBase64}`,
      };
    }

    return {
      success: false,
      error: 'No placard data found',
    };
  } catch (error) {
    console.error('Placard preview error:', error);
    throw error;
  }
};
